(function ($) {
  const onboarding = $('.onboarding-flow');
  const setCookie = (name, value, days) => {
    let expires = '';
    const pathname = `; path=${location.pathname}`;

    // We'll modify days logic based on future integration
    if (days) {
      const date = new Date();

      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = `; expires=${date.toUTCString()}`;
    }

    document.cookie = `${name}=${value || ''}${expires}${pathname}`;
  };

  const setCookieOnboarding = () => {
    const button = $('#gotit');

    button.on('click', (e) => {
      e.preventDefault();

      $('#onboarding').modal('hide');
      setCookie('onboardingContainer', true, 365);
    });
  };

  window.onload = () => {
    if (onboarding.length) {
      if (document.cookie.indexOf('onboardingContainer') == -1) {
        $('#onboarding').modal('show');
      }
    }
  };

  const init = () => {
    setCookieOnboarding();
  };

  $(init);
}(jQuery));
